export const getAssetTagName = (assetTypeId: number) => {
  switch (assetTypeId) {
    case 0:
      return 'Image';
    case 1:
      return 'Video';
    case 2:
      return 'Music';
    case 3:
      return 'CoverPhoto';
    case 4:
      return 'Text';
    case 5:
      return 'TributeVideo';
  }
};
